export default __webpack_public_path__ + "static/media/Nainital_1.25ddc334.jpg";